import { environment } from 'src/environments/environment';

export class AppGsvDomainConstant {

  static readonly URI_GATEWAY_GSV: string = environment.serverApiUrlGsv;
  static readonly BASE_URL_ADMINISTRACION: string = 'gsv-parametrizer/api/v1/';
  static readonly BASE_URL_ADMINISTRACION_QR: string = 'api/admin/qr/v1/';
  static readonly BASE_URL_ADMINISTRACION_LOCAL: string = '8113/buc/api/manager/v1/';
  static readonly BASE_URL_ADMINISTRACION_LOCAL_MODULO_BEPS: string = 'http://localhost:8081/';
  static readonly URI_GATEWAY_GSV_LOCAL: string = 'https://localhost.dcsas.com.co:';
  
}
